module.exports = __webpack_public_path__ + "img/icon-news.cded4033.svg";